module.exports = __webpack_public_path__ + "img/20200401.cb6cf0ba.png";